import { Base } from "../Base";
export class Class extends Base {
    key;
    value;
    class = "record";
    _name;
    get name() {
        return (this._name ??= `Record<${this.key.name}, ${this.value.name}>`);
    }
    get definition() {
        return Object.assign(super.definition, { key: this.key.definition, value: this.value.definition });
    }
    constructor(key, value, name) {
        super();
        this.key = key;
        this.value = value;
        this._name = name;
    }
    is(value) {
        let result;
        if (!value || typeof value != "object" || Array.isArray(value))
            result = false;
        else if (this.key.class == "string" &&
            "allowed" in this.key &&
            Array.isArray(this.key.allowed) &&
            this.key.allowed.every(v => typeof v == "string"))
            result =
                Object.keys(value).length == this.key.allowed.length && this.key.allowed.every(key => this.value.is(value[key]));
        else
            result = Object.entries(value).every(([k, v]) => (this.key.is(k) || this.key.is(`${+k}` == k ? +k : k)) && this.value.is(v));
        return result;
    }
    prune(value) {
        return (this.is(value) &&
            Object.fromEntries(Object.entries(value).map(([key, value]) => [this.key.prune(key), this.value.prune(value)])));
    }
    flawed(value) {
        const result = super.flawed(value);
        return (result && {
            ...result,
            flaws: Object.entries(value)
                .map(([key, value]) => [key, this.key.flawed(key) || this.value.flawed(value)])
                .map(([key, flaw]) => flaw && Object.assign(flaw, { property: key }))
                .filter((flaw) => !!flaw),
        });
    }
    static create(key, value, name) {
        return new Class(key, value, name);
    }
}
//# sourceMappingURL=Class.js.map